import { computed } from 'vue'

export const tipsMoneyReason = () => {
  const listReason = computed(() => ['Sisa Kembalian', 'Apresiasi Pelayanan', 'Lainnya'])

  return {
    listReason
  }
}
